import type { Template } from "@/types";

export const LA_06_H3_V3: Template[] = [
    {
        id: "la-06-h3v3-01",
        name: "LA 01 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 112, y: 65, width: 187, height: 129, rotation: 0, imageRotation: 0 },
            { id: "2", x: 112, y: 201, width: 187, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 112, y: 338, width: 187, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 306, y: 65, width: 260, height: 400, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 65, width: 260, height: 400, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 65, width: 260, height: 400, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-02",
        name: "LA 02 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 120, y: 46, width: 281, height: 439, rotation: 0, imageRotation: 0 },
            { id: "2", x: 408, y: 46, width: 143, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 408, y: 269, width: 143, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 787, y: 46, width: 457, height: 281, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 335, width: 225, height: 149, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1020, y: 335, width: 225, height: 149, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-03",
        name: "LA 03 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 109, y: 46, width: 457, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 109, y: 335, width: 225, height: 149, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 335, width: 225, height: 149, rotation: 0, imageRotation: 0 },
            { id: "4", x: 800, y: 46, width: 281, height: 439, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1089, y: 46, width: 143, height: 216, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1089, y: 271, width: 143, height: 214, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-04",
        name: "LA 04 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 120, y: 46, width: 320, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 120, y: 271, width: 320, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 447, y: 46, width: 112, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 447, y: 196, width: 112, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 447, y: 345, width: 112, height: 141, rotation: 0, imageRotation: 0 },
            { id: "6", x: 752, y: 82, width: 523, height: 365, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-05",
        name: "LA 05 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 109, y: 45, width: 225, height: 313, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 45, width: 225, height: 313, rotation: 0, imageRotation: 0 },
            { id: "3", x: 109, y: 366, width: 148, height: 119, rotation: 0, imageRotation: 0 },
            { id: "4", x: 265, y: 366, width: 148, height: 119, rotation: 0, imageRotation: 0 },
            { id: "5", x: 420, y: 366, width: 147, height: 119, rotation: 0, imageRotation: 0 },
            { id: "6", x: 861, y: 45, width: 306, height: 440, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-06",
        name: "LA 06 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 97, width: 446, height: 339, rotation: 0, imageRotation: 0 },
            { id: "2", x: 453, y: 97, width: 219, height: 339, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 97, width: 220, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 271, width: 220, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 907, y: 97, width: 219, height: 339, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 97, width: 219, height: 339, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-07",
        name: "LA 07 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 97, width: 446, height: 339, rotation: 0, imageRotation: 0 },
            { id: "2", x: 680, y: 97, width: 220, height: 339, rotation: 0, imageRotation: 0 },
            { id: "3", x: 453, y: 97, width: 219, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 453, y: 271, width: 219, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 907, y: 97, width: 219, height: 339, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 97, width: 219, height: 339, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-08",
        name: "LA 08 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 97, width: 446, height: 339, rotation: 0, imageRotation: 0 },
            { id: "2", x: 453, y: 97, width: 219, height: 339, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 97, width: 220, height: 339, rotation: 0, imageRotation: 0 },
            { id: "4", x: 907, y: 97, width: 219, height: 339, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1133, y: 97, width: 219, height: 166, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 271, width: 219, height: 165, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-09",
        name: "LA 09 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 53, y: 67, width: 142, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 203, y: 67, width: 292, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 270, width: 292, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 353, y: 270, width: 142, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 503, y: 67, width: 530, height: 398, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1040, y: 67, width: 260, height: 398, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-10",
        name: "LA 10 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 53, y: 67, width: 142, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 203, y: 67, width: 292, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 270, width: 292, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 353, y: 270, width: 142, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 503, y: 67, width: 260, height: 398, rotation: 0, imageRotation: 0 },
            { id: "6", x: 771, y: 67, width: 530, height: 398, rotation: 0, imageRotation: 0 }
        ],
    }
];